import React, { useState } from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';
import emailjs from '@emailjs/browser';

const Appointment = () => {

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: null, message: '' }); // 'success' | 'error' | null
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    department: '',
    doctor: '',
    msg: ''
  });

  // Handler for input field changes
  const handleInputChange = event => {
    const { name, value } = event.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    // EmailJS Public Key (puoi spostarla in .env se preferisci)
    const PUBLIC_KEY = "gDwh8PdMs8PPZ2eKs";
    if (!PUBLIC_KEY) {
      console.warn('Missing EmailJS public key.');
    }

    setLoading(true);
    setStatus({ type: null, message: '' });

    // Parametri richiesti dal template EmailJS:
    // {{name}}, {{email}}, {{phone}}, {{department}}, {{msg}}
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      department: formData.department,
      msg: formData.msg,
      // opzionali solo se li aggiungi nel template:
      // date: formData.date,
      // doctor: formData.doctor,
    };

    try {
      await emailjs.send(
        'service_sanwp3q',     // << service ID
        'template_yncha5l',    // << template ID
        templateParams,
        { publicKey: PUBLIC_KEY }
      );

      setFormData({
        name: '',
        email: '',
        phone: '',
        date: '',
        department: '',
        doctor: '',
        msg: ''
      });

      setStatus({
        type: 'success',
        message: 'Richiesta inviata correttamente. Verrai ricontattato al più presto per confermare la prenotazione.'
      });
    } catch (err) {
      console.error('EmailJS error:', err);
      setStatus({
        type: 'error',
        message: 'Si è verificato un errore durante l’invio. Riprova tra poco o contattaci via email/telefono.'
      });
    } finally {
      setLoading(false);
    }
  };

  // Pillola di stato (inline fallback se non hai classi dedicate)
  const pillStyle = (type) => ({
    textAlign: 'center',
    width: '100%',
    display: 'inline-block',
    marginTop: 16,
    padding: '10px 14px',
    borderRadius: 999,
    fontSize: 14,
    lineHeight: 1.3,
    border: '1px solid',
    background: type === 'success' ? '#e8f5ee' : '#fdecea',
    borderColor: type === 'success' ? '#a6d8b8' : '#f5c6cb',
    color: type === 'success' ? '#1b5e20' : '#7b1116'
  });

  return (
    <section id="appointment" className="st-shape-wrap st-gray-bg" style={{marginTop:'5px'}}>
      <div className="st-shape4">
        <img src="/shape/section_shape.png" alt="/shape/section_shape.png" />
      </div>
      <div className="st-shape6">
        <img src="/shape/contact-shape3.svg" alt="/shape/contact-shape3.svg" />
      </div>
      <div className="st-height-b120 st-height-lg-b80" />
      <SectionHeading
        title="Richiedi un appuntamento"
        subTitle="Prenota la tua visita in modo semplice e veloce. La tua salute intima merita attenzione personalizzata.<br>Fai richiesta tramite il form e verrai ricontattato quanto prima per confermare la tua prenotazione!"
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <form
              method="POST"
              className="st-appointment-form"
              id="appointment-form"
              onSubmit={onSubmit}
            >
              {/* RIMOSSI hidden input non necessari per EmailJS */}

              <div id="st-alert1" />
              <div className="row">
                <div className="col-lg-6">
                  <div className="st-form-field st-style1">
                    <label>Nome</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Inserire nome per intero..."
                      onChange={handleInputChange}
                      value={formData.name}
                      required
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="st-form-field st-style1">
                    <label>Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Es: esempio@gmail.com"
                      onChange={handleInputChange}
                      value={formData.email}
                      required
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="st-form-field st-style1">
                    <label>Telefono</label>
                    <input
                      type="text"
                      id="phone"
                      name="phone"
                      placeholder="Es: +39 333 222 1111"
                      onChange={handleInputChange}
                      value={formData.phone}
                      required
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="st-form-field st-style1">
                    <label>Servizio</label>
                    <div className="st-custom-select-wrap">
                      <select
                        name="department"
                        id="department"
                        className="st_select1"
                        data-placeholder="Seleziona servizio"
                        onChange={handleInputChange}
                        value={formData.department}
                        required
                      >
                        <option value="">Seleziona servizio</option>
                        <option value="Ginecologia e Benessere Intimo">Ginecologia e Benessere Intimo</option>
                        <option value="Medicina Estetica">Medicina Estetica</option>
                        <option value="Trattamenti Ginecologia">Trattamenti Ginecologia</option>
                        <option value="Servizi Estetica">Servizi Estetica</option>
                        <option value="Trattamenti Viso">Trattamenti Viso</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="st-form-field st-style1">
                    <label>Messaggio</label>
                    <textarea
                      cols={30}
                      rows={10}
                      id="msg"
                      name="msg"
                      placeholder="Descrivi il tipo di servizio di cui hai bisogno..."
                      onChange={handleInputChange}
                      value={formData.msg}
                      required
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <button
                    className="st-btn st-style1 st-color1 st-size-medium"
                    type="submit"
                    id="appointment-submit"
                    name="submit"
                    disabled={loading}
                  >
                    {loading ? "Invio in corso..." : "Prenota Ora !"}
                  </button>
                </div>
              </div>
            </form>

            {/* Pillola stato sotto al form */}
            {status.type && (
              <div role="status" aria-live="polite" style={pillStyle(status.type)}>
                {status.message}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Appointment;
